import { render, staticRenderFns } from "./Suntech4G.vue?vue&type=template&id=cd20edc2"
import script from "./Suntech4G.vue?vue&type=script&lang=js"
export * from "./Suntech4G.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports